import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Actions from "@redux/app";
import { PaymentService } from "@services";
import utils from "@utils";
import { DirectDepositAccountModal, Loader } from "../../../components";

class DirectDeposit extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showDirectDepositModal: false,
			depositAccount: {
				data: {},
				loading: false,
			},
		};
	}

	componentDidMount() {
		const { user } = this.props;

		if (user.IsRKPay) this.getDirectDepositAccount();

		// If linked directly to RKPay, show the modal immediately
		if (window.location.hash === "#RKPay") {
			this.setState({ showDirectDepositModal: true });
		}
	}

	/** Retrieves all direct deposit account information the user has */
	getDirectDepositAccount = () => {
		const { lang } = global;

		this.setState(({ depositAccount }) => ({
			depositAccount: { ...depositAccount, loading: true },
		}));

		PaymentService.getData()
			.then(({ data }) => {
				this.setState({ depositAccount: { data: data ?? {}, loading: false } });
			})
			.catch(({ response }) => {
				if (response?.status !== 404) {
					utils.notify({
						type: "error",
						message: response?.data?.Message ?? lang.t("Error loading Payment Methods"),
					});
				}

				this.setState(({ depositAccount }) => ({
					depositAccount: { ...depositAccount, loading: false },
				}));
			});
	};

	/** A callback method used get the most up to date direct deposit information */
	saveDepositAccountCallback = () => {
		const { updateUser } = this.props;
		updateUser("IsRKPay", true);
		this.setState({ showDirectDepositModal: false });
		this.getDirectDepositAccount();
	};

	render() {
		const { lang } = global;
		const { user } = this.props;
		const {
			showDirectDepositModal,
			depositAccount: { data, loading },
		} = this.state;

		return (
			<div className="my-account-panel">
				<div className="my-account-panel-header direct-deposit-header">
					<div>
						<h4 className="title">{lang.t("Direct Deposit Information")}</h4>
						<h5 className="subtitle">
							{lang.t(
								"Direct deposit information to collect department fees or funds_",
							)}
						</h5>
					</div>
					<If condition={user.IsRKPay}>
						<button
							type="button"
							className="btn btn-link"
							id="my-account-edit-direct-deposit-btn"
							onClick={() => this.setState({ showDirectDepositModal: true })}
							disabled={loading}
						>
							{lang.t("Edit Direct Deposit")}
						</button>
					</If>
				</div>
				<div className="my-account-panel-body">
					<Choose>
						<When condition={loading}>
							<div className="row">
								<div className="col-xs-12 text-center">
									<Loader
										active
										spinnerOnly
									/>
								</div>
							</div>
						</When>
						<When condition={!user.IsRKPay}>
							<div className="row">
								<div className="col-xs-12 text-center">
									<button
										type="button"
										className="btn btn-primary"
										onClick={() =>
											this.setState({ showDirectDepositModal: true })
										}
									>
										{lang.t("Add Direct Deposit")}
									</button>
								</div>
							</div>
						</When>
						<Otherwise>
							<div className="row">
								<span className="col-xs-6 col-sm-4">
									<strong>{`${lang.t("Routing Number")}:`}</strong>
								</span>
								<span className="col-xs-6 col-sm-7 text-left">
									{data?.BankAccount?.RoutingNumber ?? ""}
								</span>
							</div>
							<div className="row">
								<span className="col-xs-6 col-sm-4">
									<strong>{`${lang.t("Account Number")}:`}</strong>
								</span>
								<span className="col-xs-6 col-sm-7 text-left">
									{data?.BankAccount?.AccountNumber
										? `****${data.BankAccount.AccountNumber}`
										: ""}
								</span>
							</div>
							<div className="row">
								<span className="col-xs-6 col-sm-4">
									<strong>{`${lang.t("Account Holder")}:`}</strong>
								</span>
								<span className="col-xs-6 col-sm-7 text-left">
									{data?.BankAccount?.AccountHolderName ?? ""}
								</span>
							</div>
							<If condition={data?.LegalEntity}>
								<div className="row">
									<span className="col-xs-6 col-sm-4">
										<strong>{`${lang.t("Verification Status")}:`}</strong>
									</span>
									<span className="col-xs-6 col-sm-7 text-left">
										<span className="label label-default my-account-badge">
											{data.LegalEntity.VerificationStatus}
										</span>
									</span>
								</div>
							</If>
						</Otherwise>
					</Choose>
				</div>
				<DirectDepositAccountModal
					show={showDirectDepositModal}
					onHide={() => this.setState({ showDirectDepositModal: false })}
					data={data}
					callback={this.saveDepositAccountCallback}
					ref={ref => {
						this._directDepositAccountModal = ref;
					}}
					user={user}
					isOrganizationDepositAccount={false}
				/>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => ({
	updateUser: bindActionCreators(Actions, dispatch).updateUser,
});

DirectDeposit.propTypes = {
	updateUser: PropTypes.func.isRequired,
	user: PropTypes.object,
};

DirectDeposit.defaultProps = {
	user: {},
};

export default connect(null, mapDispatchToProps)(DirectDeposit);
